var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCountry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10C17.5 14.1422 14.1422 17.5 10 17.5M17.5 10C17.5 5.85787 14.1422 2.5 10 2.5M17.5 10C17.5 11.3807 14.1422 12.5 10 12.5C5.85787 12.5 2.5 11.3807 2.5 10M17.5 10C17.5 8.61925 14.1422 7.5 10 7.5C5.85787 7.5 2.5 8.61925 2.5 10M10 17.5C5.85787 17.5 2.5 14.1422 2.5 10M10 17.5C8.61925 17.5 7.5 14.1422 7.5 10C7.5 5.85787 8.61925 2.5 10 2.5M10 17.5C11.3807 17.5 12.5 14.1422 12.5 10C12.5 5.85787 11.3807 2.5 10 2.5M10 2.5C5.85787 2.5 2.5 5.85787 2.5 10",
    stroke: "#ffffff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCountry);
export default __webpack_public_path__ + "static/media/Country.f58dccda34d4adbf70a8761c7efb048c.svg";
export { ForwardRef as ReactComponent };